import { accent, accentText } from 'screens/Checkout/v2/tokens';
import { isUxV2 } from 'v2/flag';
import './wallet-express.css';

/**
 * Marque Google Pay, telle que Google la distribue pour ses propres boutons
 * (asset officiel `light_gpay.svg` servi par le SDK Google Pay). Le « G » garde
 * ses quatre couleurs, imposées par la charte ; seul le mot « Pay » suit la
 * couleur du texte, pour la version sur fond sombre.
 */
function GooglePayMark() {
  return (
    <svg className="mw-mark-google" width="54" height="23" viewBox="0 0 41 17" role="img" aria-label="Google Pay" focusable="false">
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zm7.668 2.287c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568m11.853.262l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z"
          fill="currentColor"
        />
        <path d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" fill="#4285F4" />
        <path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703" fill="#34A853" />
        <path d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z" fill="#FABB05" />
        <path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" fill="#E94235" />
      </g>
    </svg>
  );
}

/**
 * Logotype Apple Pay vectorisé : la pomme et « Pay » de l'illustration officielle d'Apple (Apple Pay Mark,
 * `Apple_Pay_Mark_RGB_041619.svg` des ressources marketing Apple Pay), tracés repris tels quels, sans la bordure de la
 * marque ; cadrage sur le logotype (viewBox), couleur = celle du texte (blanc sur la tuile noire : le bouton Apple Pay
 * noir d'Apple). Hauteur de 20 px : « P » de 14,8 px, celui de « Pay » dans la marque Google Pay voisine (14,5 px).
 */
function ApplePayLogotype() {
  return (
    <svg
      className="mw-mark-apple-svg"
      width="49"
      height="20"
      viewBox="20.98 29.25 123.16 50.56"
      role="img"
      aria-label="Apple Pay"
      focusable="false"
      style={{ display: 'block' }}
    >
      <g fill="currentColor">
        <path d="M43.5084,35.7697c1.4032-1.755,2.3554-4.1116,2.1043-6.5197c-2.0541,0.1022-4.5606,1.3551-6.0118,3.1116c-1.303,1.5041-2.4563,3.9593-2.1557,6.2665C39.751,38.8281,42.0547,37.4756,43.5084,35.7697" />
        <path d="M45.5865,39.0786c-3.3486-0.1995-6.1956,1.9004-7.7948,1.9004c-1.5999,0-4.0487-1.7999-6.6972-1.7514c-3.4472,0.0506-6.6458,1.9997-8.3952,5.0996c-3.598,6.2015-0.9495,15.4004,2.5494,20.4511c1.6992,2.4988,3.7469,5.2501,6.4452,5.1512c2.5494-0.1,3.5486-1.6507,6.6475-1.6507c3.0966,0,3.9967,1.6507,6.6954,1.6007c2.7986-0.05,4.5482-2.5,6.2474-5.0011c1.9492-2.8485,2.7471-5.5989,2.7973-5.7499c-0.0502-0.05-5.3964-2.101-5.446-8.2509c-0.0505-5.1494,4.1974-7.5987,4.3973-7.7506C50.634,39.5791,46.8859,39.1791,45.5865,39.0786" />
        <path d="M78.9732,32.1102c7.278,0,12.3464,5.0168,12.3464,12.3209c0,7.3302-5.1722,12.3733-12.5284,12.3733H70.733v12.8142h-5.8225V32.1102H78.9732z M70.733,51.9172h6.6804c5.0689,0,7.9538-2.729,7.9538-7.46c0-4.7305-2.8849-7.434-7.9278-7.434H70.733V51.9172z" />
        <path d="M92.7641,61.8472c0-4.8092,3.6651-7.5645,10.4231-7.9801l7.252-0.4423v-2.0792c0-3.0413-2.0015-4.7049-5.5623-4.7049c-2.9376,0-5.069,1.5076-5.5107,3.821h-5.2509c0.1564-4.8609,4.731-8.3956,10.9175-8.3956c6.6543,0,10.9952,3.4831,10.9952,8.8894v18.6631h-5.3808v-4.4964h-0.1298c-1.5337,2.9371-4.913,4.7822-8.5781,4.7822C96.5329,69.9044,92.7641,66.6815,92.7641,61.8472z M110.4392,59.4296v-2.1058l-6.4723,0.4161c-3.639,0.2337-5.5362,1.5854-5.5362,3.9509c0,2.2873,1.9754,3.7694,5.0684,3.7694C107.4499,65.4602,110.4392,62.9382,110.4392,59.4296z" />
        <path d="M120.9746,79.6522v-4.4964c0.364,0.0512,1.2475,0.1033,1.7152,0.1033c2.5736,0,4.0291-1.091,4.9131-3.8987l0.5199-1.6636l-9.8516-27.2928h6.0822l6.8624,22.1457h0.1298l6.8624-22.1457h5.9268l-10.2156,28.6706c-2.3394,6.5761-5.0168,8.734-10.6834,8.734C122.7941,79.8086,121.3642,79.7565,120.9746,79.6522z" />
      </g>
    </svg>
  );
}

/**
 * Marque Apple Pay.
 *
 * App actuelle (v1) : glyphe  (U+F8FF) de la police système d'Apple. Ce caractère de la zone privée d'Unicode
 * n'existe que dans les polices d'Apple : sous Windows, Android ou Linux, il ne s'affiche pas et la tuile ne montre
 * que « Pay » (retour de Ségolène du 07/10 : « il manque le logo Apple à gauche de Pay »). Depuis le 24/09, la tuile
 * est proposée partout sauf sur Android (utils/wallets.ts), donc aussi sous Windows. Inchangé tant que la nouvelle
 * interface est éteinte (SPEC § 1, règle 1).
 *
 * Nouvelle interface (v2) : logotype vectoriel d'Apple (ApplePayLogotype), le même dessin sur tous les appareils.
 */
function ApplePayMark() {
  if (isUxV2()) return <ApplePayLogotype />;
  return (
    <span className="mw-mark-apple" aria-label="Apple Pay" role="img">
      <span aria-hidden="true"></span>
      <span aria-hidden="true">Pay</span>
    </span>
  );
}

export type WalletId = 'applepay' | 'googlepay';

interface WalletExpressProps {
  applePay: boolean;
  googlePay: boolean;
  selected: WalletId | null;
  onSelect: (id: WalletId) => void;
  /** Le séparateur n'a de sens que si des moyens classiques suivent. */
  withSeparator?: boolean;
  /**
   * Le Nouveau Panier englobe déjà ses options dans un `radiogroup` : les
   * tuiles ne doivent pas en ouvrir un second, deux groupes imbriqués n'ayant
   * aucun sens pour un lecteur d'écran.
   */
  ownGroup?: boolean;
}

/**
 * Bloc « paiement express », en tête du choix du moyen de paiement.
 *
 * Rendu à l'identique dans les deux paniers : un portefeuille n'est pas un
 * moyen de paiement comme un autre, sa marque fait le travail de
 * reconnaissance et il n'y a ni champ à remplir ni sous-titre à lire. D'où une
 * tuile portant la marque plutôt qu'une ligne de liste, et une présentation qui
 * ne dépend pas du panier qui l'accueille.
 */
export function WalletExpress({ applePay, googlePay, selected, onSelect, withSeparator = true, ownGroup = true }: WalletExpressProps) {
  if (!applePay && !googlePay) return null;

  const tile = (id: WalletId, label: string, mark: React.ReactNode) => (
    <button
      type="button"
      role="radio"
      aria-checked={selected === id}
      aria-label={label}
      className={`mw-wallet${selected === id ? ' mw-wallet--selected' : ''}`}
      onClick={() => onSelect(id)}
    >
      {mark}
      <span className="mw-wallet-check" aria-hidden="true" />
    </button>
  );

  return (
    <div className="mw-wallets" style={{ '--mw-accent': accent, '--mw-accent-text': accentText } as React.CSSProperties}>
      <p className="mw-wallets-label">Paiement express</p>
      <div className="mw-wallets-grid" role={ownGroup ? 'radiogroup' : undefined} aria-label={ownGroup ? 'Paiement express' : undefined}>
        {applePay && tile('applepay', 'Payer avec Apple Pay', <ApplePayMark />)}
        {googlePay && tile('googlepay', 'Payer avec Google Pay', <GooglePayMark />)}
      </div>
      <p className="mw-wallets-note">
        {selected
          ? 'Vous serez redirigé(e) vers la page de paiement sécurisée, puis ramené(e) ici automatiquement.'
          : 'Payez en un geste, sans saisir votre carte.'}
      </p>
      {withSeparator && (
        <div className="mw-wallets-sep" aria-hidden="true">
          <span>ou payer autrement</span>
        </div>
      )}
    </div>
  );
}
